<template>
  <div class="introduce content">
    <div class="index-banner img-row">
      <img
        :src="getWebConfig.about_image"
        alt=""
      />
      <p>大赛章程</p>
    </div>
        <div class="introduce-content">
          <p class="article-title h5">
            {{page_info.name}}
          </p>
          <div class="introduce-text" v-html="page_info.content">
            <!-- <h3 class="text-center">第一章 总则</h3>
            <p>
              第一条 竞赛性质：“致敬英雄”全国青少年文化艺术创作主题教育竞赛由中国少年儿童文化艺术基金会主办，旨在引导少年儿童崇尚英雄、捍卫英雄、学习英雄、关爱英雄，具有创新性、引领性、示范性、公益性，每年举办一届，接受教育部和文旅部的审核与监管。
              第二条　竞赛宗旨：以“品读英雄故事，致敬心中英雄，传承红色基因”为宗旨，通过表达英雄故事，传递精神力量，赓续精神血脉。
              第三条 竞赛原则：
              1.坚持正确的政治方向。严格遵照教育部相关要求开展竞赛活动，贯彻党的教育方针、文艺方针，服务于“立德树人”教育根本任务，为培养德智体美劳全面发展的社会主义建设者和接班人贡献力量。
              2.坚持公益性原则，坚持零收费。 3.坚持公平、公正、公开的评选原则。
              4.坚持专业性原则。搭建高水平竞赛平台，引领中小学生艺术教育和写作教学，提高中小学生的核心素养，促进素质教育发展。
              第四条
              竞赛理念：依托《致敬英雄》等党史教育专题内容，旨在落实立德树人的根本任务，以潜移默化的方式引导少年儿童崇尚英雄、捍卫英雄、学习英雄、关爱英雄，从小听党话、感党恩、跟党走，厚植家国情怀，积极培育和践行社会主义核心价值观。
            </p> -->
          </div>
        </div>
  </div>
</template>
  
<script>
import { Stock, chinaMap } from "@/store/mixin.js";

export default {
  mixins: [Stock, chinaMap],
  data(){
    return{
      page_info:{}
    }
  },
  created(){
    // //console.log(this.$route.params)
    this.getPageHome()
  },
  methods:{
    async getPageHome(){
      let data={
        keys:'大赛章程'
      },
      res=await this.$api.getPageHome(data)
      //console.log('大赛章程',res);
      if(res.code==1){
        this.page_info=res.data
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
.introduce-content {
  margin: 20px 0;
  width: 100%;
  padding: 0 40px 40px;
  background-color: #fff;
}
.introduce-text {
  padding: 20px 0;
  & p,span,&{
    line-height: 2.5;
  }
}
</style>
    